import React from "react";
// import {useGetBasket} from "@/features/basketActions/model/useGetBasket";
import rootStores from '@/Stores/RootStores';

const BasketButton = ({children, className = ''}) => {
    // const {getBasket} = useGetBasket();
    const {basketStore = {}} = rootStores;

    return (
        <button type={`button`} className={className} onClick={basketStore.getBasket}>{children}</button>
    );
};

export default BasketButton;
